(() => {
  const recommend = (rows, shoe, calf) => {
    const candidates = rows.filter(row => shoe >= row.shoe[0] && shoe <= row.shoe[1]);
    if (calf === null) return {kind: candidates.length ? 'provisional' : 'no_match', candidates};
    const fits = candidates.filter(row => calf >= row.calf[0] && calf <= row.calf[1]);
    fits.sort((a, b) => a.calf[1] - b.calf[1]);
    return {kind: fits.length ? 'result' : 'no_match', size: fits.at(-1)?.size, overlap: fits.length > 1, candidates: fits};
  };
  if (typeof module !== 'undefined' && module.exports) { module.exports = recommend; return; }
  const setup = () => document.querySelectorAll('[data-levya-size-guide]').forEach(dialog => {
    if (dialog.dataset.lsgReady) return;
    const opener = [...document.querySelectorAll('[data-lsg-opener]')].find(button => button.getAttribute('aria-controls') === dialog.id);
    if (!opener) return;
    dialog.dataset.lsgReady = 'true';
    const find = selector => dialog.querySelector(selector);
    const labels = JSON.parse(find('[data-lsg-labels]').textContent);
    const form = find('.lsg-form');
    const fields = Object.fromEntries(['shoe','height','calf'].map(key => [key, form.elements.namedItem(key)]));
    const steps = [...dialog.querySelectorAll('[data-lsg-step]')];
    const error = find('[data-lsg-error]');
    const chart = [...dialog.querySelectorAll('tbody tr')].map(row => {
      const cells = [...row.cells].map(cell => cell.textContent.trim());
      const range = value => (value.match(/\d+(?:[.,]\d+)?/g) || []).map(number => Number(number.replace(',', '.')));
      return {size: cells[0], shoe: range(cells[1]), calf: range(cells[2])};
    }).filter(row => row.shoe.length === 2 && row.calf.length === 2);
    let current = 0, unknown = false, result;
    const showError = text => { error.textContent = text; error.hidden = false; };
    const show = (index, focus = true) => {
      current = index;
      error.hidden = true;
      steps.forEach((step, i) => { step.hidden = i !== index; });
      find('[data-lsg-result]').hidden = index !== 4;
      find('[data-lsg-progress]').hidden = index === 4;
      find('.lsg-intro').hidden = index === 4;
      find('.lsg-nav').hidden = index === 4;
      find('[data-lsg-back]').hidden = index === 0;
      find('[data-lsg-counter]').textContent = `${labels.step} ${Math.min(index + 1, 4)} ${labels.of} 4`;
      find('[data-lsg-fill]').style.width = `${Math.min(index + 1, 4) * 25}%`;
      if (focus) (index === 4 ? find('[data-lsg-result-title]') : steps[index].querySelector('h3')).focus();
    };
    const displayResult = () => {
      result = recommend(chart, fields.shoe.valueAsNumber, unknown ? null : fields.calf.valueAsNumber);
      find('[data-lsg-result-title]').textContent = labels[result.kind];
      find('[data-lsg-size]').textContent = result.size || result.candidates.map(row => row.size).join(' / ');
      find('[data-lsg-explanation]').textContent = labels[result.kind === 'result' ? (result.overlap ? 'overlap' : 'matched') : result.kind === 'provisional' ? 'uncertain' : 'no_match_help'];
      find('[data-lsg-apply]').hidden = result.kind !== 'result';
      find('[data-lsg-apply-help]').hidden = result.kind !== 'result';
      find('.lsg-result-icon').hidden = result.kind !== 'result';
      const usage = form.elements.namedItem('usage').value;
      const summary = find('.lsg-summary'); summary.replaceChildren();
      for (const [label,value] of [[labels.shoe_label,fields.shoe.value],[labels.height_label,`${fields.height.value} cm`],[labels.calf_label,unknown ? labels.not_measured : `${fields.calf.value} cm`],[labels.usage,labels[usage]]]) {
        const term = document.createElement('dt'), description = document.createElement('dd');
        term.textContent = label; description.textContent = value; summary.append(term,description);
      }
      show(4);
      if (result.kind !== 'result') find('.lsg-chart').open = true;
    };
    opener.addEventListener('click', () => { dialog.showModal(); show(current); });
    find('[data-lsg-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
    });
    dialog.addEventListener('close', () => opener.focus());
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (current === 4) return;
      if (current < 3) {
        const input = fields[['shoe','height','calf'][current]];
        if (!input.checkValidity()) { showError(labels.invalid); input.reportValidity(); input.focus(); return; }
        if (current === 2) unknown = false;
      } else if (!form.elements.namedItem('usage').value) { showError(labels.usage_required); return; }
      if (current === 3) displayResult(); else show(current + 1);
    });
    find('[data-lsg-back]').addEventListener('click', () => show(Math.max(0,current - 1)));
    find('[data-lsg-unknown]').addEventListener('click', () => { unknown = true; show(3); });
    find('[data-lsg-restart]').addEventListener('click', () => { form.reset(); unknown = false; find('.lsg-chart').open = false; show(0); });
    dialog.querySelectorAll('[data-lsg-adjust]').forEach(button => button.addEventListener('click', () => {
      const input = button.parentElement.querySelector('input');
      if (!input.value) input.value = input.name === 'calf' ? '35' : input.defaultValue;
      else if (button.dataset.lsgAdjust === '1') input.stepUp(); else input.stepDown();
      error.hidden = true;
    }));
    find('[data-lsg-apply]').addEventListener('click', async () => {
      if (!result?.size) return;
      const purchase = dialog.closest('.levya-purchase');
      const productForm = purchase.querySelector('.levya-form');
      const variants = JSON.parse(productForm.querySelector('[data-levya-variants]').textContent);
      const native = [...productForm.querySelectorAll('.levya-option')];
      const sizeIndex = native.findIndex(select => [...select.options].some(option => option.value === result.size));
      if (sizeIndex < 0) { showError(labels.unavailable); return; }
      const rows = [...purchase.querySelectorAll('.moonbundle-variant-row')].filter(row => row.getClientRects().length && row.closest('.moonbundle-variants-box')?.getClientRects().length !== 0);
      const targets = rows.map(row => [...row.querySelectorAll('select')]);
      const choices = targets.length ? targets : [native];
      const valid = choices.every(selects => {
        const sizes = selects[sizeIndex];
        const options = selects.map((select,i) => i === sizeIndex ? result.size : select.value);
        return sizes && [...sizes.options].some(option => option.value === result.size && !option.disabled) && variants.some(variant => variant.available && variant.options.every((value,i) => value === options[i]));
      });
      if (!valid) { showError(labels.unavailable); return; }
      const button = find('[data-lsg-apply]'); button.disabled = true;
      try {
        for (let i = 0; i < choices.length; i++) {
          const selectors = targets.length ? [...rows[i].querySelectorAll('select')] : native;
          const select = selectors[sizeIndex];
          select.value = result.size;
          select.dispatchEvent(new Event('change',{bubbles:true}));
          await new Promise(resolve => requestAnimationFrame(resolve));
        }
        if (choices.some(selects => !selects[sizeIndex].isConnected || selects[sizeIndex].value !== result.size)) { showError(labels.unavailable); return; }
        const status = purchase.querySelector('[data-lsg-status]'); status.textContent = labels.applied;
        dialog.close();
      } finally { button.disabled = false; }
    });
    show(0,false);
  });
  setup();
  document.addEventListener('shopify:section:load',setup);
})();
